<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.GET_IMAGE.DATE'|translate }} <span class="required">*</span></label>

        <ui-calendar [single]="true"
                     [inputStyle]="uiInputStyles.noLabel"
                     [inputConfig]="{padding: '8px 23px 8px 13px'}"
                     [selectDateRange]="dateRangeStartSig()"
                     [dateFormat]="'MMM, dd. h:mm:ss a'"
                     [inputTypeTimeFormat]="'HH:mm:ss'"
                     [no2MinDiff]="true"
                     (rangeSelected)="onRangeChange($event)">
        </ui-calendar>
    </div>
</div>